module.exports = __webpack_public_path__ + "static/apple-touch-icon-120x120-eda6630ef9f9cdb344e4532c30512eb4.png";